import Galeria from '@/views/intranet/galeria/Galeria.vue'
import GaleriaAlbumes from '@/views/intranet/galeria-albumes/GaleriaAlbumes.vue'
import GaleriaAlbumSingle from '@/views/intranet/galeria-album-single/GaleriaAlbumSingle.vue'

export const galeria = {
  path: '/galeria',
  name: 'Galeria',
  component: Galeria,
  meta: { requiresAuth: true }
}

export const galeriaAlbumes = {
  path: '/galeria/:year/:month',
  name: 'GaleriaAlbumes',
  component: GaleriaAlbumes,
  meta: { requiresAuth: true }
}

export const galeriaAlbumSingle = {
  path: '/galeria/:id_galeria',
  name: 'GaleriaAlbumSingle',
  component: GaleriaAlbumSingle,
  meta: { requiresAuth: true }
}
